import { reactQueryGet } from "../helpers/backendRequestHelpers";
import { crmFilters } from "../helpers/urlHelpers/internalApi/crmFilters";

// TODO: check how those types can be inferred from the BE specs
interface CrmFilterConfiguration {
  filter_configurations: CrmFilterConfigurationItem[];
}

type CrmFilterConfigurationItem = LocationConfiguration | NearMeConfiguration;

export interface BaseFilterConfiguration {
  enabled: boolean;
  input_type: "location" | "near_me";
  key: "location" | "near_me";
  label: "Location" | "Near Me";
  payload: NearMePayload | null;
}

export interface LocationConfiguration extends BaseFilterConfiguration {
  input_type: "location";
  key: "location";
  label: "Location";
  payload: null;
  type: "standard";
}

interface NearMePayload {
  community_member_profile_field: {
    id: string;
    text: string;
  } | null;
  near_me_location_filter_values: {
    source: string;
    id: string;
    name: string;
  } | null;
  require_user_to_provide_more_precise_location: boolean;
}

export interface NearMeConfiguration extends BaseFilterConfiguration {
  input_type: "near_me";
  key: "near_me";
  label: "Near Me";
  payload: NearMePayload;
  type: "action";
}

const configuration = () =>
  reactQueryGet<CrmFilterConfiguration>(crmFilters.configuration());

export const crmFiltersApi = {
  configuration,
};
